import React, { useContext } from 'react'

import { useLocation } from 'react-router-dom'

import { TitleContext } from '@providers/TitleProvider'
import { useSession } from '@stores/globalData/globalData.store'
import { isLearnPcPreview } from '@utils/page-routes'

const SellerNameLink: React.FC = () => {
  const {
    title: { seller },
  } = useContext(TitleContext)
  const session = useSession()
  const { pathname } = useLocation()

  if (!seller) return null

  if (!session.isDefaultCommunity() || isLearnPcPreview(pathname)) {
    return <p className="leading-3">{seller.name}</p>
  }

  return (
    <a title={seller.name} className="leading-3 text-orange" href={seller.homepage_uri}>
      {seller.name}
    </a>
  )
}

export default SellerNameLink
